import React, { useMemo, useState } from 'react';
import { useShared } from '../sharedStyles';

// Season picker (v2.7, PO ask 2026-09-14): common season names for this
// year and next in a drop-down, plus "Custom…" that reveals a text field.
// YMCA leagues run several seasons a year (Winter, Spring, Summer, Fall);
// school-year programs prefer "2026-27". The value stays free text on the
// server (programs.season, seasons.name), so nothing existing changes.
export const seasonOptions = (now = new Date()) => {
  const y = now.getFullYear();
  const out = [];
  for (const year of [y, y + 1]) {
    for (const s of ['Winter', 'Spring', 'Summer', 'Fall']) out.push(`${s} ${year}`);
    out.push(`${year}-${String(year + 1).slice(2)}`);
  }
  return out;
};

const CUSTOM = '__custom';

export default function SeasonField({ id = 'season', value, onChange, label = 'Season', required = false, placeholder = 'Winter 2027 or 2026-27 Rec League' }) {
  const shared = useShared();
  const options = useMemo(() => seasonOptions(), []);
  const listed = options.includes(value);
  const [custom, setCustom] = useState(!!value && !listed);
  const mode = custom || (!!value && !listed) ? CUSTOM : (value || '');

  const pick = (v) => {
    if (v === CUSTOM) { setCustom(true); onChange(''); return; }
    setCustom(false);
    onChange(v);
  };

  return (
    <div>
      <label style={shared.label} htmlFor={id}>{label}</label>
      <select id={id} style={shared.input} value={mode} onChange={(e) => pick(e.target.value)} required={required && mode !== CUSTOM}>
        <option value="">Select a season…</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
        <option value={CUSTOM}>Custom…</option>
      </select>
      {mode === CUSTOM && (
        <input
          id={`${id}-custom`}
          aria-label={`${label} (custom)`}
          style={{ ...shared.input, marginTop: '6px' }}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          maxLength={60}
          required={required}
          autoFocus
        />
      )}
    </div>
  );
}
